import { createSlice } from '@reduxjs/toolkit';

export const studentScore = createSlice({
    name: 'studentScore',
    initialState: {
        data: {}
    },
    reducers: {
      fetchSuccess(state, action) {
        const { payload } = action;
        state.data = payload;
      },
    },
}).reducer;